import i18next from 'i18next';
import * as yup from 'yup';

const schema = yup.object().shape({
  email: yup.string().email(() => i18next.t('validations.emailFormat')).required(() => i18next.t('validations.required')),
});

export default schema;
